<template>
  <div class="legal-docs-layout">
    <DocsAnchorNav
      :items="anchors"
      :active-anchor="activeAnchor"
      class="legal-docs-layout__sidebar"
    />
    <div class="legal-docs-layout__content">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import DocsAnchorNav from './DocsAnchorNav.vue';
import { useActiveAnchor } from '@/composables/useActiveAnchor';

interface AnchorItem {
  label: string;
  anchor: string;
}

interface Props {
  anchors: AnchorItem[];
}

const props = defineProps<Props>();

const anchorIds = props.anchors.map((a) => a.anchor);
const { activeAnchor } = useActiveAnchor(anchorIds);
</script>

<style scoped lang="scss">
.legal-docs-layout {
  display: flex;
  align-items: flex-start;
  gap: var(--space-10);

  &__sidebar {
    // handled by DocsAnchorNav internal display:none / display:block
  }

  &__content {
    flex: 1;
    min-width: 0;
    max-width: 800px;
  }
}
</style>
